export const AudioPlaySvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="0.5" y="0.5" width="27" height="27" rx="7.5" fill="white" />
    <rect x="0.5" y="0.5" width="27" height="27" rx="7.5" stroke="#DDE3F2" />
    <path
      d="M17.6593 12.3615L13.1469 9.20285C11.8214 8.27496 10 9.22326 10 10.8413V17.1587C10 18.7767 11.8214 19.725 13.1469 18.7972L17.6593 15.6385C18.7968 14.8423 18.7968 13.1577 17.6593 12.3615Z"
      fill="#7587A5"
    />
  </svg>
)
